export const photoRatingSettingsPath = '/rating-settings'
